import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import { addCloudDevice } from './js/addcamera';
import { deleteCloudDevice } from './js/deletecamera';

export default class UniviewCameraDetails extends Component {
	constructor(props) {
		super(props);

		let array = sessionStorage.getItem('devices').split(',');
		let i = this.props.param.index
		let device_id = array[i].substring(array[i].indexOf('Device ID:') + 10, array[i].indexOf('\n'));
		if (device_id != '') array[i] = array[i].substring(array[i].indexOf('\n') + 1, array[i].length);
		let device_name = array[i].substring(array[i].indexOf('Device Name:') + 12, array[i].indexOf('\n'));
		if (device_name != '') array[i] = array[i].substring(array[i].indexOf('\n') + 1, array[i].length);
		let device_model = array[i].substring(array[i].indexOf('Dev Model:') + 10, array[i].indexOf('\n'));

		let username = '';
		let password = '';

		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		this.controller_mac_addr = controller_info.mac_addr;
		this.controller_username = controller_info.username;
		username = uniview_info[this.controller_mac_addr][this.controller_username].username;
		password = uniview_info[this.controller_mac_addr][this.controller_username].password;

		this.state = {
			device_id: device_id,
			device_name: device_name,
			device_model: device_model,
			index: this.props.param.index,
			username: username,
			password: password
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('UniviewCameras');
	}

	//Add Camera
	handleRegister = () => {
		//Form validation
		if (this.state.device_name == '') {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		window.app.showLoading();
		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		addCloudDevice(this.saveSuccess, this.saveFailed, uniview_info.username, uniview_info.password, this.state.registerCode, this.state.deviceName);
	}

	saveSuccess = (result) => {
		window.app.hideLoading();
		// Remove the last comma
		if (result.substring(result.length - 1, result.length) == ',') result = result.substring(0, result.length - 1);
		sessionStorage.setItem('devices', result);
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('UniviewCameras')
	}

	saveFailed = (result) => {
		//console.log(result)
		window.app.hideLoading();
		alert(this.props.receiver.getString('ipcam_deviceaddedfailed'));
	}

	handleChangeDeviceName = (val) => {
		const message = val.slice(0, 20);
		this.setState({ device_name: message })
	}

	//Delete camera
	handleDeleteCamera = () => {
		let confirmPopUp = window.confirm(this.props.receiver.getString("conf_del"));
		if (confirmPopUp == true) {
			window.app.showLoading();
			deleteCloudDevice(this.deleteSuccess, this.deleteFailed, this.state.username, this.state.password, this.state.device_id);
		}
	}

	deleteSuccess = () => {
		window.app.hideLoading();
		//window.app.showToast(this.props.receiver.getString('uniview_cameradeleted'), 3000);
		//alert(this.props.receiver.getString("uniview_cameradeleted"));
		this.handlePrevious();
	}

	deleteFailed = () => {
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('uniview_failedtodeletecamera'), 3000);
		//alert(this.props.receiver.getString("uniview_failedtodeletecamera"));
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			width: '100%',
			color: 'white',
			fontFamily: "system-ui, -apple-system, -apple-system-font, 'Segoe UI', 'Roboto', sans-serif",
			height: this.props.height,
		}

		let container_style = {
			justifyContent: 'center',
			alignItems: 'center',
			height: '700px',
			overflow: 'auto',
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('uniview_device_details')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'delete'}
						handleRightButton={this.handleDeleteCamera}
					/>

					{/* Fields */}
					<div style={container_style}>

						{/* Device Name */}
						<div style={{ textAlign: 'center', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
							<Editbox id='deviceName' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('ipcam_devicename')} inputType='text' maxLength="20" onChange={(event) => this.handleChangeDeviceName(event.target.value)} value={this.state.device_name} required />
						</div>

						{/* Make Sure Device Online Placeholder */}
						<div style={{ textAlign: 'center', color: '#6E6E6E' }}>
							<p>{this.props.receiver.getString("ipcam_makesuredeviceonline")}</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}